import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import Protected from './Protected';
import CustomerPayment from './components/CustomerSection/CustomerPayment';
import ErrorStatus from './components/CustomerSection/ErrorStatus';
import SuccessStatus from './components/CustomerSection/SuccessStatus';
import DealerForgotPassword from './components/Layout/DealerForgotPassword';
import DealerLogin from './components/Layout/DealerLogin';
import Logout from './components/Layout/Logout';
import ForgotPasswordSlide1 from './components/Layout/ForgotPassword1';
import ForgotPasswordSlide2 from './components/Layout/ForgotPassword2';
import Login from './components/Layout/Login';
import Authenticate from './components/Layout/Authenticate';

const App = () => {
    return (
        <Routes>
            <Route path='/' element={<Authenticate />} />
            <Route path='/Logout' element={<Logout />} />
            <Route path='/login' element={<Authenticate />} />
            <Route path='/Admin' element={<Login />} />        
            <Route path='/CustomerPayment' element={<CustomerPayment />} />
            <Route path='/Authenticate' element={<Authenticate />} />
            <Route path='/SuccessStatus' element={<SuccessStatus />} />
            <Route path='/ErrorStatus' element={<ErrorStatus />} />
            <Route path='/forgotPassword1' element={<ForgotPasswordSlide1 />} />
            <Route path='/DealerForgotPassword' element={<DealerForgotPassword />}/>
            <Route path='/forgotPassword' element={<ForgotPasswordSlide2 />} />
            {AppRoutes.map((item, index) =>
                <Route path={`/${item.path}`} key={`menus${index}`} element={<Protected Component={item.element} PageUrl={item.path} />} />
            )}
        </Routes>
    );
}
export default App;